import {Injectable} from '@angular/core';

@Injectable()
export class EnumsService {
  constructor() {}

  getEnumKeyByEnumValue(myEnum: any, enumValue: string | number): string {
    const keys = Object.keys(myEnum).filter((x) => myEnum[x] === enumValue);
    return keys.length > 0 ? keys[0] : null;
  }
}
